export const MOBILE = 530;
export const SMALL_TABLET = 700;
export const TABLET = 1000;
export const SMALL_SCREEN = 1400;
export const MEDUIM_SCREEN = 1850;
export const LARGE_SCREEN = 2250;
